import { render, staticRenderFns } from "./FaceSwap.vue?vue&type=template&id=cee164fa&scoped=true"
import script from "./FaceSwap.vue?vue&type=script&lang=js"
export * from "./FaceSwap.vue?vue&type=script&lang=js"
import style0 from "./FaceSwap.vue?vue&type=style&index=0&id=cee164fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee164fa",
  null
  
)

export default component.exports